export const targetManagedNoteStyle = {
  padding: '8px 12px',
  background: 'var(--color-surface-secondary, #f5f5f5)',
  borderRadius: '4px',
  fontSize: '0.8125rem',
  lineHeight: 1.5,
  color: 'var(--color-text-secondary, #666)',
  marginBottom: '8px'
}
